// Loads the face-api.js browser bundle on demand (only the kiosk and the HR enrolment screen need it),
// so the main app bundle stays small. Files live in  public/face/  (see the deploy notes).
const SRC = '/face/face-api.js';
export const MODEL_URL = '/face/model';

let loading = null;
export function loadFaceApi() {
  if (window.faceapi) return Promise.resolve(window.faceapi);
  if (loading) return loading;
  loading = new Promise((resolve, reject) => {
    const s = document.createElement('script');
    s.src = SRC;
    s.async = true;
    s.onload = () => (window.faceapi ? resolve(window.faceapi) : reject(new Error('Face library loaded but is empty')));
    s.onerror = () => { loading = null; reject(new Error('Could not load /face/face-api.js - copy the face files into the frontend public/face folder.')); };
    document.head.appendChild(s);
  });
  return loading;
}
